const en = {
  siteName: "Akkuzey Yapı Building Materials",
  siteNameShort: "Akkuzey Yapı",

  // Interface strings (buttons, screen-reader labels, empty states)
  ui: {
    close: "Close",
    back: "Back",
    previous: "Previous",
    next: "Next",
    menu: "Menu",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    logoAlt: "Akkuzey Yapı Building Materials",
    dealerLogoAlt: "Dealership logo",
    whatsapp: "Message us on WhatsApp",
    productCategories: "Product Categories",
    subProducts: "Sub-products",
    subCategoryNotFound: "Sub-category not found",
    emptySubCategory: "There are no products in this sub-category.",
    code: "Code",
  },

  homeNavbar: "Home",
  chooseLanguage: "Choose Language",
  products: "Products",
  corporate: "Corporate",
  affiliates: "Affiliates",
  dealerships: "Dealerships",
  newsNavbar: "News",
  storesFooter: "Our Stores",
  search_placeholder: "Search product...",
  contactNavbar: "Contact",
  searchPlaceholder: "Search product...",
  favorites: {
    title: "My Favorites",
    emptyMessage: "You have no favorite products.",
  },
  navbar: {
    searching: "Searching…",
    suggestCategories: "Categories",
    suggestProducts: "Products",
    seeAllResults: "See all results ({{count}})",
    searchPlaceholder: "Type the product you are looking for…",
    search: "SEARCH",
    callUs: "Call Us",
    myCart: "My Cart",
    allCategories: "All Categories",
    cats: {
      insaat: "Construction",
      hirdavat: "Hardware",
      elAletleri: "Hand Tools",
      boya: "Paint",
      yapiKimyasallari: "Building Chemicals",
      tesisat: "Plumbing",
      banyo: "Bath & Fittings",
      elektrik: "Electrical",
      makinalar: "Machinery",
      kesme: "Cutting & Drilling",
    },
  },
  topBanner: {
    message:
      "akkuzey@hotmail.com | +90 537 798 11 29 | Istanbul GMT+3 | Monday–Saturday (08:00–20:00) | Sunday (11:00–18:30)",
  },
  subMenus: {
    corporate: {
      about: "About Us",
      contact: "Contact",
      qualityPolicy: "Quality Policy",
      complaints: "Suggestion & Complaint Form",
      faq: "FAQ",
    },
    affiliates: {
      construction: "Akkuzey Construction",
      automotive: "Akkuzey Automotive",
    },
  },
  home: {
    featuredBrandsEyebrow: "Featured Brands",
    featuredBrandsTitle: "Brands you trust, one click away",
    brandProductCount: "{{count}} products",
    newArrivalsEyebrow: "New Arrivals",
    newArrivalsTitle: "Recently added to the catalog",
    seeCatalog: "See the full catalog",
    viewDetails: "View Details",
    hero: {
      eyebrow: "Building materials since 1972",
      title: "From bathroom to hardware, complete supply from a single source.",
      subtitle:
        "For over half a century, Akkuzey Yapı has supplied construction, plumbing, hardware and bathroom–kitchen products, wholesale and retail, from Zeytinburnu, İstanbul.",
      ctaPrimary: "Browse Products",
      ctaSecondary: "Contact Us",
      stats: {
        foundedValue: "1972",
        foundedLabel: "Founded",
        dealersValue: "40+",
        dealersLabel: "Authorised dealerships",
        storesValue: "2",
        storesLabel: "Stores · İstanbul",
      },
    },
    brands: {
      title: "Our authorised dealerships",
      link: "View all",
    },
    wholesale: {
      eyebrow: "Wholesale supply",
      title: "Wholesale brick and cement delivered to your site.",
      subtitle:
        "We supply brick, cement and core building materials at wholesale prices, delivered directly to your construction site. Get a quote based on your quantities and delivery schedule.",
      items: {
        brick: "Brick",
        brickNote: "Hollow, solid and aerated concrete",
        cement: "Cement",
        cementNote: "Bagged and bulk",
        delivery: "Site delivery",
        deliveryNote: "Dispatch to suit your project schedule",
      },
      ctaPrimary: "Request a Wholesale Quote",
      ctaSecondary: "Call Now",
      phone: "+90 537 798 11 29",
    },
    cta: {
      title: "Let's find the right material for your project.",
      subtitle:
        "Contact us for product, stock and pricing information, or visit our stores.",
      primary: "Contact Us",
      secondary: "Our Stores",
    },
    campaigns: {
      showerSets: {
        title: "New Season Shower Sets",
        brand: "VitrA · ECA · Creavit",
      },
      paintRollers: {
        title: "Paint Rollers and Brushes",
        brand: "Dekor",
      },
      sealants: {
        title: "Silicones, Mastics and Mounting Foams",
        brand: "Selsil",
      },
      basinMixers: {
        title: "A Wide Range of Basin Mixers",
        brand: "ECA · VitrA · Creavit",
      },
      interiorPaints: {
        title: "Interior Wall Paints",
        brand: "Filli Boya · Polisan · Marshall",
      },
      bathroomKitchen: {
        title: "Make a Difference in Your Bathroom & Kitchen",
        brand: "Premium Products",
      },
      bathroomAccessories: {
        title: "Bathroom Accessories & More",
        brand: "Discounted Prices",
      },
      modernAccessories: {
        title: "Modern Accessories",
        brand: "Special Prices",
      },
      bathroomCabinets: {
        title: "Hundreds of Bathroom Cabinet Options",
        brand: "World-Class Brands",
      },
      selsil: {
        title: "Which Selsil?",
        brand: "Find What You Need",
      },
      sprayPaint: {
        title: "Hundreds of Spray Paint Colors!",
        brand: "Maximum Quality",
      },
    },
  },
  bathroomAccessories: {
    title: "Bathroom Accessories",
    products: {
      soapDish: "Soap Dish",
      towelHolder: "Towel Holder",
      emergencySupportShelf: "Angled Support Shelf Towel Holder",
      cornerSoapDish: "3-Tier White Bathroom Corner Soap Rack",
    },
  },
  bathroomCabinets: {
    title: "Bathroom Cabinets",
    products: {
      firdevsSet: "Firdevs Bathroom Cabinet Set",
      klasikSet: "Classic Bathroom Cabinet Set",
      asyaSet: "Asya Bathroom Cabinet Set",
      quadrumAsma: "Quadrum Wall-Mounted Bathroom Cabinet",
    },
  },
  bathroomKitchen: {
    title: "Bathroom & Kitchen Faucets",
    products: {
      begonyaShowerSet: "Begonya Chrome Overhead Shower Set",
      spiralKitchenFaucet: "Flexible Kitchen Faucet",
      ritaSinkFaucet: "Rita Sink Faucet",
      ritaBathFaucet: "Rita Bath Faucet",
      laraBlackSinkFaucet: "Lara Black Sink Faucet",
      laraBlackBathFaucet: "Lara Black Bath Faucet",
      alyaSinkFaucet: "Alya Sink Faucet",
      alyaBathFaucet: "Alya Bath Faucet",
    },
    barcode: "Barcode",
    code: "Product Code",
    brand: "Brand",
    color: "Color",
    colors: {
      chrome: "Chrome",
      black: "Black",
    },
  },
  stores: {
    title: "Our Stores",
    subtitle: "Visit our stores to experience our service and product quality.",
    map: "Map",
    istanbul: {
      city: "Istanbul",
      name: "Main Store",
      address: "Çırpıcı, 75/2. Sk. No:109, 34025 Zeytinburnu/Istanbul",
      phone: "+90 537 798 11 29",
      email: "akkuzey@hotmail.com",
      hours: "Mon–Sat: 08:00–20:00, Sun: 11:00–18:30",
    },
    ankara: {
      city: "Istanbul",
      name: "Store",
      address: "Beştelsiz, 1. Yol Sk. No:7, 34020 Zeytinburnu/Istanbul",
      phone: "+90 537 798 11 29",
      email: "akkuzey@hotmail.com",
      hours: "Mon–Sat: 08:00–20:00, Sun: 11:00–18:30",
    },
  },
  modernAccessories: {
    title: "Modern Accessories",

    products: {
      suspendedCeilingPanel: "Acoustic Suspended Ceiling Panel",
      modernDoorHandleBlack: "Matte Black Modern Door Handle",
      modernDoorHandleChrome: "Satin Chrome Modern Door Handle",
      sensorSoapDispenser: "Automatic Sensor Soap Dispenser",
    },
  },

  selsil: {
    title: "Selsil Product Catalogue",
    barcode: "Barcode",
    code: "Code",
    brand: "Brand",
    color: "Color",
    colors: {
      white: "White",
      black: "Black",
      red: "Red",
      green: "Green",
      blue: "Blue",
      gray: "Gray",
      lightGray: "Light Gray",
      transparent: "Transparent",
    },
    products: {
      siliconeTransparent: { name: "Transparent Silicone 280 GR (2527)" },
      siliconeWhite: { name: "White Silicone 280 GR (2528)" },
      siliconeBlack: { name: "Black Silicone 280 GR (2529)" },
      masticWhite: { name: "White Mastic 450 GR" },
      foam600gr: { name: "Foam 600 GR (2619)" },
      rtvHeatSilicone: { name: "RTV High Temp Silicone Red 280ML" },
      miraculouspackage: {
        name: "Selsil Pak Miracle Foam Cleaner 500 ML",
      },
      SelsilCleaning: {
        name: "Selsil Pak All-Purpose Miracle Cleaner 500 GR",
      },
      StainRemover: {
        name: "Selsil Pak Stain Remover Spray 150 ML",
      },
      puMasticBlack: { name: "PU Mastic Black 280 ML" },
      puMasticGray: { name: "PU Mastic Gray 280 ML" },
      puMasticWhite: { name: "PU Mastic White 280 ML" },
      multiPurposeSpray: { name: "Multi-Purpose Spray 400ML (50600)" },
      selsilSprayB: { name: "Selsil Spray B 400ML" },
    },
  },
  sprayPaint: {
    title: "Spray Paint Catalogue",
    productName: "Akçalı Spray Paint 400 ml {{color}}",
    code: "Code",
    unit: "Unit",
    category: "Category",
    color: "Color",
    categories: { paint: "PAINT" },
    colors: {
      white: "White",
      black: "Black",
      red: "Red",
      green: "Green",
      blue: "Blue",
      gray: "Gray",
      lightGray: "Light Gray",
      lightBrown: "Light Brown",
      orange: "Orange",
      lightGreen: "Light Green",
      taxiYellow: "Taxi Yellow",
      bordeaux: "Bordeaux",
      purple: "Purple",
      lightBlue: "Light Blue",
      beadBlue: "Bead Blue",
      turquoise: "Turquoise",
      navyBlue: "Navy Blue",
      glossWhite: "Gloss White",
      beige: "Beige",
      chromeYellow: "Chrome Yellow",
      brown: "Brown",
      glossBlack: "Gloss Black",
      matteWhite: "Matte White",
      matteBlack: "Matte Black",
      trafficWhite: "Traffic White",
      pearlWhite: "Pearl White",
      mossGreen: "Moss Green",
      anthracite: "Anthracite",
      gloss: "Gloss",
      matte: "Matte",
      saten: "Satin",
      darkGray: "Dark Gray",
      smoke: "Smoke",
      bronze: "Bronze",
      lightAluminium: "Light Aluminium",
      mediumGray: "Medium Gray",
      bumperBlack: "Bumper Black",
      bumperWhite: "Bumper White",
      enamelStoveBrown: "Enamel Stove Paint Brown",
      metallicBlack: "Metallic Black",
      metallicYellow: "Metallic Yellow",
      metallicBlue: "Metallic Blue",
      grayWhite: "Gray White",
      oxideYellow: "Oxide Yellow",
      fuchsia: "Fuchsia",
      machineRed: "Machine Red",
      scarlet: "Scarlet",
      fluorescentYellow: "Fluorescent Yellow",
      fluorescentLilac: "Fluorescent Lilac",
      fluorescentRed: "Fluorescent Red",
      fluorescentDarkRed: "Fluorescent Dark Red",
      fluorescentOrange: "Fluorescent Orange",
      plasticPrimer: "Plastic Surface Primer",
    },
    products: {
      akcaliSpray400ml: "Akçalı Spray Paint 400 ml",
      akcaliVarnish400ml: "Akçalı Varnish 400 ml",
      akcaliBumperPaint400ml: "Akçalı Bumper Paint 400 ml",
      akcaliWheelPaint400ml: "Akçalı Wheel Paint 400 ml",
    },
  },

  dealershipsPage: {
    title: "Dealerships",
    subtitle:
      "Reach our products easily through our widespread dealer network.",
    brands: {
      abb: "ABB",
      armaş: "Armaş",
      baylan: "Baylan",
      ecesan: "Ecesan",
      fluke: "Fluke",
      isonem: "Isonem",
      kalekim: "Kalekim",
      karbon: "Karbon",
      makel: "Makel",
      metoba: "Metoba",
      optimum: "Optimum",
      pelsan: "Pelsan",
      pimtaş: "Pimtaş",
      polisan: "Polisan",
      selsil: "Selsil",
      sista: "Sista",
      viko: "Viko",
      vitra: "Vitra",
      yaparlar: "Yaparlar",
      yds: "YDS",
      alarko: "Alarko",
      askaynak: "Askaynak",
      ayvaz: "Ayvaz",
      beybi: "Beybi",
      bmex: "BMEX",
      bonuspan: "Bonuspan",
      bosh: "Bosch",
      çayırva: "Çayırva",
      dekor: "Dekor",
      dewalt: "Dewalt",
      duyar: "Duyar",
      ebitt: "Ebitt",
      eca: "ECA",
      feica: "Feica",
      fırat: "Fırat",
      honey: "Honeywell",
      kale: "Kale",
      knipex: "Knipex",
      köse: "Köse",
      metresan: "Metresan",
      marshall: "Marshall",
      stanley: "Stanley",
      tekno: "Tekno",
      turkuaz: "Turkuaz",
      pakkens: "Pakkens",
      rothenberg: "Rothenberg",
      sonneflex: "Sonneflex",
      sumak: "Sumak",
      yalteks: "Yalteks",
    },
  },
  product: {
    zoom: "Zoom",
    close: "Close",
    share: "Share",
    linkCopied: "Link copied",
    notFound: "Product not found.",
    backToCatalog: "Back to catalog",
    options: "Options",
    askWhatsapp: "Ask on WhatsApp",
    whatsappText: "Hello, I would like price and stock information about {{ad}}{{secenek}}.",
    call: "Call Us",
    description: "Product Description",
    autoDescription: "{{ad}} is a {{marka}} product in the {{kategori}} group.",
    optionsSentence: "Available in {{sayi}} options: {{liste}}.",
    priceInfo: "Contact us on WhatsApp or by phone for current price and stock; we offer special prices for wholesale orders.",
    metaDescription: "{{ad}} — {{marka}} {{kategori}}. Get price and stock information from Akkuzey Building Materials.",
    related: "Similar Products",
    viewAll: "View all",
    trust: {
      wholesaleTitle: "Wholesale and Retail",
      wholesale: "Special prices for sites and contractors",
      sinceTitle: "Since 1972",
      since: "Building material supply in Zeytinburnu",
      quoteTitle: "Fast Quote",
      quote: "Send your list in one WhatsApp message",
    },
  },
  recent: {
    eyebrow: "Pick up where you left off",
    title: "Recently Viewed",
    clear: "Clear list",
  },
  calc: {
    materialList: "Material list",
    print: "Print / PDF",
    copyLink: "Copy link",
    suggested: "Suggested products for this job",
    stepArea: "Area and dimensions",
    stepProduct: "Product and application",
    approx: "approx.",
    tabsHint: {
      boya: "Liters and cans",
      duvar: "Pieces and mortar",
      seramik: "Boxes, adhesive, grout",
      beton: "m³ and cement",
      alci: "Number of bags",
      alcipan: "Boards, profiles, screws",
    },
    tile: {
      area: "Area to tile",
      straight: "Straight lay (10% waste)",
      diagonal: "Diagonal lay (15% waste)",
      stepTile: "Tile size",
      tileWidth: "Tile width",
      tileHeight: "Tile length",
      thickness: "Tile thickness",
      boxM2: "Area per box",
      boxHint: "Printed on the box (e.g. 1.44 m² for 60×60)",
      stepAdhesive: "Adhesive and grout",
      adhesive: "Adhesive consumption",
      adhesiveHint: "5–7 kg/m² for large tiles, 3–4 kg/m² for small ones",
      joint: "Joint width",
      result: "Boxes needed",
      boxes: "boxes",
      tiles: "Tiles",
      adhesiveItem: "Tile adhesive",
      groutItem: "Grout",
      browse: "Browse adhesives",
      whatsapp: "Hello, I calculated {{olcu}} cm tiles for {{alan}} m²: {{adet}} pcs ({{kutu}} boxes), {{torba}} bags of adhesive and {{derz}} kg of grout. Could I get a price?",
    },
    concrete: {
      thickness: "Thickness",
      type: "Application",
      type_sap: "Screed",
      type_grobeton: "Lean concrete (C16)",
      type_c25: "Concrete C25",
      type_c30: "Concrete C30",
      dosage: "Cement dosage",
      dosageHint: "Cement per m³; adjust to your project",
      result: "Cement needed",
      cementBags: "bags",
      cement: "Cement",
      sand: "Sand",
      aggregate: "Sand and gravel",
      readyMix: "If you order ready-mix",
      readyMixNote: "order volume",
      volume: "Volume",
      browse: "Browse cement",
      whatsapp: "Hello, I calculated {{hacim}} m³ of {{tip}}: {{torba}} bags ({{kg}} kg) of cement. Could I get a price?",
    },
    drywall: {
      stepSystem: "Wall system",
      faces: "Faces to board",
      oneFace: "One face",
      twoFaces: "Two faces",
      layers: "Board layers",
      single: "Single layer",
      double: "Double layer",
      spacing: "Stud spacing",
      result: "Boards needed",
      boards: "boards",
      boardItem: "Plasterboard",
      cProfile: "C stud",
      studs: "studs",
      uProfile: "U track (floor-ceiling)",
      screws: "Drywall screws",
      tape: "Joint tape",
      jointFiller: "Joint filler",
      browse: "Browse drywall systems",
      whatsapp: "Hello, I calculated a {{alan}} m² drywall: {{levha}} boards, {{c}} C studs, {{u}} U tracks, {{vida}} screws. Could I get a price?",
    },
    eyebrow: "Material Calculator",
    title: "How much material do you need?",
    subtitle: "Enter your measurements and get an itemised material list for paint, brick and blocks, tiles, concrete and screed, plaster and drywall. Print it or send it via WhatsApp for a quote.",
    tabs: {
      seramik: "Tiles",
      beton: "Concrete and Screed",
      alcipan: "Drywall Partition",
      boya: "Paint",
      duvar: "Brick and AAC Block",
      alci: "Plaster",
    },
    askQuote: "Get a price for this amount",
    disclaimer: "Results are estimates and may vary by surface and product. Check the product label or ask your contractor for exact amounts.",
    width: "Width",
    length: "Length",
    height: "Height",
    openings: "Door / window area",
    openingsHint: "Area to exclude",
    netArea: "Net area",
    liter: "liters",
    pieces: "pcs",
    waste: "Waste allowance",
    wasteHint: "For breakage and cutting loss",
    viewProduct: "View product",
    paint: {
      item: "Paint",
      primer: "Primer",
      primerNote: "One coat, ~12 m²/L",
      addPrimer: "Include primer",
      mode_oda: "By room size",
      mode_alan: "By total area",
      includeCeiling: "Paint the ceiling too",
      area: "Area to paint",
      coats: "Coats",
      coatUnit: "coats",
      coverage: "Coverage",
      coverageHint: "From the product label; usually 8–12 m²/L for interior paints",
      result: "Paint needed",
      packages: "Suggested cans",
      browse: "Browse paints",
      whatsapp: "Hello, I calculated {{kat}} coats of paint for {{alan}} m²: about {{litre}} liters ({{paket}}). Could I get a price?",
    },
    wall: {
      mortar: "Masonry mortar",
      thinMortar: "AAC thin-bed mortar",
      length: "Wall length",
      block: "Brick / block",
      custom: "Enter size manually",
      blockLength: "Block length",
      blockHeight: "Block height",
      joint: "Joint thickness",
      jointHint: "~10 mm for brick, ~3 mm for AAC with thin mortar",
      result: "Pieces needed",
      perM2: "Per m²",
      browse: "Browse bricks and blocks",
      whatsapp: "Hello, I calculated {{blok}} for a {{alan}} m² wall: about {{adet}} pieces. Could I get a price?",
    },
    plaster: {
      type: "Product type",
      type_makine: "Machine plaster",
      type_perlitli: "Perlite plaster (manual)",
      type_saten: "Finishing plaster",
      area: "Application area",
      thickness: "Thickness",
      consumption: "Consumption",
      consumptionHint: "Approximate; adjust according to the technical sheet",
      bag: "Bag",
      result: "Bags needed",
      bags: "bags",
      total: "Total",
      bagSize: "Bag weight",
      browse: "Browse plasters",
      whatsapp: "Hello, I calculated {{tip}} ({{kalinlik}} mm) for {{alan}} m²: about {{torba}} bags ({{kg}} kg). Could I get a price?",
    },
    navbarItem: "Calculator",
    teaserEyebrow: "Free tool",
    teaserTitle: "Calculate how much material you need",
    teaserText: "Calculate paint, brick and plaster amounts from your measurements and send the result via WhatsApp for a quote.",
    teaserCta: "Start calculating",
  },
  shop: {
    searchPlaceholder: "Search products…",
    searchAllPlaceholder: "Search all products…",
    searchResultsFor: "Results for “{{q}}”",
    searchNoResult: "No products match your search.",
    brandProducts: "{{marka}} Products",
    categoryProducts: "Products in this category",
    cart: "Cart",
    cartTitle: "My Quote List",
    cartEmpty: "Your list is empty.",
    cartEmptyHint: "Use “Add to Cart” next to a product to build your quote list.",
    addToCart: "Add to Cart",
    added: "Added",
    remove: "Remove",
    clear: "Clear List",
    selectSize: "Select size",
    subCategories: "Sub-categories",
    brands: "Brands",
    allBrands: "All",
    clearFilters: "Clear filters",
    productCount: "{{count}} products",
    tileZoom: "View image",
    tileExplore: "Explore",
    noResult: "No products match these filters.",
    whatsappSend: "Request Quote via WhatsApp",
    whatsappIntro: "Hello, I would like information and pricing for the following products:",
    whatsappOutro: "Thank you.",
    quantity: "Qty",
    productFeatures: {
      "mukemmel-inceltici": "Excellent thinner",
      "su-bazli": "Water based",
      "makinede-renklendirilebilen-beyaz": "Machine-tintable white",
      "yuksek-kaplama-alani": "High coverage area",
      "yuzey-hatalarini-gizler": "Conceals surface flaws",
      "uzun-omurlu": "Long lasting",
      "dusuk-koku": "Low odour",
      "rahat-uygulama": "Easy application",
      "lekeleri-gizler": "Conceals stains",
      "yuksek-renk-dayanimi": "High colour retention",
      "yuksek-ortuculuk": "High opacity",
      "uzun-sureli-beyazlik": "Long-lasting whiteness",
      "hizli-kuruyan": "Fast drying",
      "tutunmayi-kuvvetlendirir-ve-son-katin-da": "Improves adhesion and topcoat durability",
      "kolay-temizlenir": "Easy to clean",
      "leke-dayanimli": "Stain resistant",
      silinebilir: "Wipeable",
      "pas-onleyici": "Rust preventive",
      "coklu-yuzeyler-icin": "For multiple surfaces",
      "hazirlar-korur-ve-guclendirir": "Prepares, protects and strengthens",
      "basit-ve-kolay-yuzey-hazirligi": "Simple and easy surface preparation",
      "astar-gerektirmez": "No primer required",
      "guclendirilmis-sizdirmazlik": "Enhanced sealing",
      "toz-tutmaz": "Dust repellent",
      "uzun-sureli-dayanim": "Long-term durability",
      "kuf-olusumuna-direncli": "Mould resistant",
      "ultra-yapisma": "Ultra adhesion",
      "sicratma-ve-damlatma-yapmaz": "No splatter or drips",
      "uv-dayanikli": "UV resistant",
      "her-turlu-hava-sartlarina-dayanikli": "Resistant to all weather conditions",
      "scuff-mark-resistant-teknolojisi": "Scuff Mark Resistant technology",
      "guclu-cizilme-direnci": "Strong scratch resistance",
      "15-kat-daha-fazla-silinebilir": "15x more wipeable",
      "ultra-yikanabilir": "Ultra washable",
      "ultra-kapatici": "Ultra covering",
      "5-kat-daha-fazla-silinebilir": "5x more wipeable",
      "kokusuz-ve-cevre-dostu": "Odourless and eco-friendly",
      "smartsil-teknolojisi": "SmartSil technology",
      yikanabilir: "Washable",
      "sicratmaz-kolay-uygulanir": "No splatter, easy to apply",
    },
  },
  notFound: {
    title: "The page you are looking for was not found.",
    subtitle:
      "The address may have changed or been mistyped. You can continue from the links below.",
    home: "Back to Home",
  },

  news: {
    title: "News",
    subtitle:
      "Find the latest sector news, updates, and press coverage about Akkuzey.",
    readMore: "Read More",
    showLess: "Show Less",
    articles: {
      newTools: {
        title: "New Generation Hand Tools Released",
        date: "20 September 2025",
        description:
          "Revolutionary new hand tools offering ergonomic design and long lifetime have entered the market.",
      },
      energyEfficiency: {
        title: "Energy Efficiency Era in Power Tools",
        date: "15 September 2025",
        description:
          "New power tools consume 30% less energy while delivering maximum performance.",
      },
      exportRecord: {
        title: "Turkey Breaks Hardware Export Record",
        date: "10 September 2025",
        description:
          "Turkey has achieved a historical record in hardware exports during the first half of 2025.",
      },
      measurementDevices: {
        title: "New Trends in Smart Measuring Devices",
        date: "05 September 2025",
        description:
          "Laser smart measuring tools provide high precision and speed in construction and engineering.",
      },
    },
  },

  qualityPolicy: {
    title: "Our Quality Policy",
    policies: {
      customerSatisfaction: {
        title: "Customer Satisfaction",
        description:
          "Providing quality service and understanding customer needs is our top priority.",
      },
      reliability: {
        title: "Reliability",
        description:
          "We work with leading manufacturers and deliver commitments on time.",
      },
      ethicalValues: {
        title: "Ethical Values",
        description:
          "Honesty, transparency, teamwork, and social responsibility guide our company culture.",
      },
      customerFocus: {
        title: "Customer Focus",
        description:
          "We analyze customer needs accurately and deliver quality & affordable products.",
      },
      quickSolution: {
        title: "Fast Solutions",
        description:
          "Our experienced team provides fast and effective solutions to customer problems.",
      },
    },
  },

  viewStores: "View Our Stores",

  footer: {
    description:
      "Akkuzey is committed to providing quality service, reliability, and sustainability.",
    contactButton: "Contact",
    corporate: {
      title: "Corporate",
      about: "About Us",
      contact: "Contact",
      complaints: "Suggestion & Complaint Form",
      faq: "FAQ",
    },
    quickMenu: { title: "Quick Menu" },
    map: { title: "Find Us Here" },
    copyright: "© {{year}} Akkuzey Building Materials. All rights reserved.",
    contactInfo: {
      title: "Contact Information",
      address: "Çırpıcı Mah. 75/2 Sk. No:109/1, Zeytinburnu / Istanbul",
      directions: "Get directions",
      weekdays: "Mon – Sat: 08:00 – 20:00",
      sunday: "Sunday: 11:00 – 18:30",
    },
    brandsStrip: {
      title: "Featured Brands",
      subtitle: "Click a brand to see all of its products.",
    },
    social: {
      whatsapp: "Message us on WhatsApp",
      instagram: "Follow us on Instagram",
    },
  },

  faq: {
    title: "Frequently Asked Questions",
    subtitle: "Find answers to the most common questions",
    contactPrompt: "Didn’t find your answer?",
    contactButton: "Go to Contact Form",
    questions: {
      qualityStandards: {
        question: "What quality standards do your products comply with?",
        answer:
          "All products comply with TSE and international standards and undergo strict quality control.",
      },
      technicalSupport: {
        question: "Can I get technical support?",
        answer:
          "Yes, our expert team provides support and application guidance for all products.",
      },
      bulkSupply: {
        question: "Do you supply materials in bulk for construction sites?",
        answer:
          "Yes, we provide bulk supply and special pricing for large-scale projects.",
      },
      productCatalogs: {
        question: "How can I access your product catalogs?",
        answer:
          "You can find our catalogs on the 'Catalogs' page or request them via email.",
      },
      customProduction: {
        question: "Do you offer custom production?",
        answer:
          "Yes, we offer customized production for specific product groups.",
      },
      training: {
        question: "Do you provide product application training?",
        answer:
          "Yes, we host periodic application training sessions by professional teams.",
      },
    },
  },

  complaintForm: {
    title: "Complaint & Suggestion Form",
    subtitle: "Your feedback is valuable to us",
    fields: {
      name: "Full Name",
      phone: "Phone Number",
      orderNumber: "Order Number",
      type: "Type",
      message: "Your Message",
    },
    placeholders: {
      name: "Enter your full name",
      phone: "5__ ___ __ __",
      orderNumber: "Enter your order number",
      message: "Please describe in detail...",
    },
    types: {
      complaint: "Complaint",
      suggestion: "Suggestion",
      request: "Request",
    },
    submit: "Submit",
    submitting: "Submitting...",
    footerNote:
      "* Fields marked with * are required. We will get back to you shortly.",
  },

  about: {
    title: "About Us",
    mainParagraph:
      "Akkuzey was founded in 1972 in Istanbul. Starting with wholesale hardware sales, our company has grown with honesty, sincerity, and a customer-first mindset.",
    corporateDevelopment: {
      title: "Corporate Development",
      description:
        "With strong R&D and a wide product range, Akkuzey continues to grow under the leadership of our founder, Adem Akkuzey.",
    },
    futureVision: {
      title: "Our Future Vision",
      description:
        "We aim to become a national chain brand through sustainable investments and customer-oriented strategies.",
    },
    quote: {
      text: `"With the legacy from our founders, we work with determination to build a lasting success story."`,
      author: "Adem Akkuzey — Chairman",
    },
  },

  contact: {
    title: "Contact",
    subtitle:
      "Our professional team is ready to support you and answer your questions.",
    offices: {
      headOffice: {
        title: "Head Office",
        address:
          "Çırpıcı Mah. 75/2 Street No:109/1\nZeytinburnu / Istanbul, Turkey",
        phone1Label: "Phone 1",
        phone1: "0 (212) 415 45 11",
        phone2Label: "Phone 2",
        phone2: "0 (537) 798 11 29",
        emailLabel: "Email",
        email: "akkuzey@hotmail.com",
      },
      branch: {
        title: "Branch",
        address:
          "Beştelsiz Mah. 5. Road No:7/A\nZeytinburnu / Istanbul, Turkey",
        phoneLabel: "Phone",
        phone: "0 (212) 665 28 72",
      },
    },
    quickContact: {
      title: "Quick Contact",
      phone: { label: "Customer Support Line", number: "+90 212 415 45 11" },
      whatsapp: { label: "Via WhatsApp", action: "Send Message" },
      email: { label: "Send Email", address: "akkuzey@hotmail.com" },
    },
  },
};

export default en;
